import React from "react";

const ERROR_HEADING = "Oops! Something went wrong.";
const ERROR_MESSAGE =
  "We're working to fix the issue. Please try again in a few minutes.";
const SUPPORT_TEXT = "If the problem persists, please";
const SUPPORT_LINK_TEXT = "contact support";
const SUPPORT_URL = "/app/support";
const HOMEPAGE_LINK_TEXT = "Return to the homepage";
const HOMEPAGE_URL = "/app";

export default function ErrorPage(): React.JSX.Element {
  return (
    <div
      className="flex-column flex-center text-center padding-xxl background-light"
      style={{ minHeight: "100vh" }}
    >
      <h1
        className="text-default margin-bottom-lg font-weight-bolder"
        style={{ fontSize: "var(--font-size-heading)" }}
      >
        {ERROR_HEADING}
      </h1>
      <p className="text-md text-secondary">{ERROR_MESSAGE}</p>
      <p className="text-md text-secondary">
        {SUPPORT_TEXT}{" "}
        <a href={SUPPORT_URL} className="text-primary">
          {SUPPORT_LINK_TEXT}
        </a>
        .
      </p>
      <p>
        <a href={HOMEPAGE_URL} className="text-primary font-weight-bold">
          {HOMEPAGE_LINK_TEXT}
        </a>
      </p>
    </div>
  );
}
